import { QueryKeys } from '../../../queryDefaults/QueryKeys';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { TasksApi } from '../../../apis/TasksApi/TasksApi.ts';
import { Task } from '../Tasks.ts';
import { patientStore } from '../../../Store/Store.ts';

export function useDeleteTaskMutations() {
    const queryClient = useQueryClient();
    const patientId = patientStore.patientId;

    return useMutation({
        mutationKey: [QueryKeys.tasks],
        mutationFn: async (taskId: string) => {
            if (!taskId || taskId === '0') 
                return;
            
            return TasksApi.deleteTask(taskId);
        },
        onSuccess: (_, taskId) => {
            queryClient.setQueryData<Task[]>([QueryKeys.tasks], (prev) => {
                return prev ? prev.filter((task) => task.id.toString() !== taskId) : [];
            });
            queryClient.setQueryData<Task[]>([QueryKeys.tasks, patientId], (prev) => {
                return prev ? prev.filter((task) => task.id.toString() !== taskId) : [];
            });
            queryClient.invalidateQueries({ queryKey: [QueryKeys.clinicalNotes] });
        },
    });
}
